import { defineComponent as z, ref as y, computed as r, openBlock as t, createElementBlock as i, normalizeStyle as n, normalizeClass as h, createVNode as b, createBlock as m, toDisplayString as g } from "vue";
import c from "./index60.js";
const x = {
  key: 0,
  class: "list-item-avatar__icon"
}, B = ["src", "alt"], E = {
  key: 2,
  class: "list-item-avatar__fallback"
}, N = {
  key: 1,
  class: "list-item-avatar__fallback-text"
}, I = /* @__PURE__ */ z({
  __name: "BaseListItemAvatar",
  props: {
    src: { default: void 0 },
    alt: { default: "" },
    size: { default: "md" },
    variant: { default: "circular" },
    icon: { default: void 0 },
    fallback: { default: void 0 },
    color: { default: "default" },
    opacity: { default: 1 }
  },
  emits: ["error"],
  setup(a, { emit: d }) {
    const l = a, u = d, s = y(!1), f = r(() => {
      const e = ["list-item-avatar"];
      return e.push(`list-item-avatar--${l.size}`), e.push(`list-item-avatar--${l.variant}`), l.color !== "default" && e.push(`list-item-avatar--${l.color}`), s.value && e.push("list-item-avatar--error"), e.join(" ");
    }), o = r(() => ({
      sm: "var(--base-size-size-40)",
      md: "44px",
      lg: "var(--base-size-size-48)"
    })[l.size]), v = (e) => {
      s.value = !0, u("error", e);
    }, k = () => {
      s.value = !1;
    };
    return (e, _) => (t(), i("div", {
      class: h(f.value),
      style: n([{ width: o.value, height: o.value }])
    }, [
      a.icon ? (t(), i("div", x, [
        b(c, {
          name: a.icon.name,
          size: a.icon.size || "md",
          color: a.icon.color || "var(--input-icon-default)",
          className: "list-item-avatar__icon-content",
          style: n({ opacity: a.opacity })
        }, null, 8, ["name", "size", "color", "style"])
      ])) : a.src && !s.value ? (t(), i("img", {
        key: 1,
        src: a.src,
        alt: a.alt,
        class: "list-item-avatar__image",
        onError: v,
        onLoad: k
      }, null, 40, B)) : (t(), i("div", E, [
        typeof a.fallback == "object" ? (t(), m(c, {
          key: 0,
          name: a.fallback.name,
          size: a.fallback.size || "md",
          className: "list-item-avatar__fallback-icon"
        }, null, 8, ["name", "size"])) : typeof a.fallback == "string" ? (t(), i("span", N, g(a.fallback), 1)) : (t(), m(c, {
          key: 2,
          name: "person",
          size: "md",
          className: "list-item-avatar__fallback-icon"
        }))
      ]))
    ], 6));
  }
});
export {
  I as default
};
